import { useNavigate } from '@tanstack/react-router';
import { TabButton, TabGroup } from '../../ui/Tabs/index.js';

/** @graph-connects none */
export interface EvaluationSectionNavProps {
  /** 今いる画面 */
  current: 'skill' | 'feedback';
}

/**
 * 評価者向けのスキル評価一覧と案件 FB 一覧を行き来するスイッチ。
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering, HR
 * @graph-business Switch between the engineer skill evaluation list and the project feedback list for evaluators
 * @graph-connects TabGroup [calls] ピル型スイッチ
 */
export function EvaluationSectionNav({ current }: EvaluationSectionNavProps) {
  const navigate = useNavigate();
  return (
    <TabGroup ariaLabel="評価の種類">
      <TabButton
        active={current === 'skill'}
        label="スキル評価"
        onClick={() => {
          void navigate({ to: '/engineer-evaluations' });
        }}
      />
      <TabButton
        active={current === 'feedback'}
        label="案件 FB"
        onClick={() => {
          void navigate({ to: '/project-feedbacks' });
        }}
      />
    </TabGroup>
  );
}
